import React from 'react';
import { BasicPageWrapper, GivelifyLabel, GivelifyLink } from '@givelify/ui';
import { pushEvent } from '@givelify/utils';
import { Grid, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CopyGivingLink from '../../../components/CopyGivingLink';
import Config from '../../../config';
import { useConnectorState, useSocialMediaGivingURL } from '../../../provider/Connector';
import { IG_GIVING_LOADED } from '../../../utils/cleverTapEvents';
import { useTranslations } from '../../../utils/translations';
import { Preview } from './Preview';
import { Breadcrumbs, Container, TipContainer } from './style';

export const InstagramGiving: React.FCC = () => {
    const { onlineGivingURLs, routePaths } = useConnectorState();
    const socialMediaGivingURL = useSocialMediaGivingURL();
    const navigate = useNavigate();

    const givingLink =
        onlineGivingURLs.find((x) => x.channel === 'INST')?.shortLink || '';

    const { pageTitle, increaseGiving, copyOrgLink } = useTranslations(
        'socialMediaGiving.instagram.page',
        {
            pageTitle: 'title',
            increaseGiving: ['title', 'desc'],
            copyOrgLink: ['title', 'desc1', 'desc2'],
        },
    );

    React.useEffect(() => {
        pushEvent(IG_GIVING_LOADED);
    }, []);

    return (
        <BasicPageWrapper showDivider contentWrapper="simple" title={pageTitle}>
            <Breadcrumbs
                active="social-root"
                hideBadge={true}
                options={[
                    {
                        id: 'social-root',
                        label: 'Social media giving',
                        onClick: () =>
                            routePaths.socialMediaGiving &&
                            navigate(socialMediaGivingURL),
                    },
                    {
                        id: 'instagram',
                        label: 'Instagram',
                    },
                ]}
            />
            <Container data-testid="instagram-giving">
                <Grid container spacing={5}>
                    <Grid item mobile={12} smallTablet={6} width="100%">
                        <GivelifyLabel
                            text={increaseGiving.title}
                            variant="body1B"
                        />
                        <GivelifyLabel
                            marginBottom={2}
                            marginTop={1}
                            text={increaseGiving.desc}
                            variant="body1"
                        />
                        <GivelifyLabel
                            text={copyOrgLink.title}
                            variant="body1B"
                        />
                        <GivelifyLabel
                            marginBottom={2}
                            marginTop={1}
                            text={copyOrgLink.desc1}
                            variant="body1"
                        />
                        <GivelifyLabel
                            marginBottom={2}
                            marginTop={1}
                            text={copyOrgLink.desc2}
                            variant="body1"
                        />
                        <CopyGivingLink givingLink={givingLink} />
                    </Grid>
                    <Grid item mobile={12} smallTablet={6} width="100%">
                        <Preview />
                    </Grid>
                </Grid>
                <TipContainer media="instagram" />
            </Container>
            <Stack marginBottom={6} marginTop={8} textAlign="center">
                <GivelifyLink
                    href={Config.supportUrl}
                    rel="noreferrer"
                    target="_blank"
                    text="Need help? Contact support"
                />
            </Stack>
        </BasicPageWrapper>
    );
};
